export default __webpack_public_path__ + "static/media/learn-title.65d64682.svg";